import { Dialog } from 'primereact/dialog'
import React, { useContext, useState } from 'react'
import { Button } from 'primereact/button'
import { useMountEffect } from 'primereact/hooks'
import { isEmpty } from 'lodash'
import { CommonContext } from '../common/context/commonContext'
import { AreaDialogProps, LocationArea, LocationDetail } from '../../types/inventory'
import { InputText } from 'primereact/inputtext'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const AreaAddDialog = (props: AreaDialogProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const [orgLocationDetail, setOrgLocationDetail] = useState<LocationDetail>()
    const [area, setArea] = useState<LocationArea>({
        centerId: '',
        areaId: '',
        areaNm: '',
        sectors: [],
    })

    useMountEffect(() => {
        if (!props.visible) return
    })

    const onClickSave = async () => {
        if (!area) return

        if (isEmpty(area.areaNm)) {
            $alert({
                icon: 'info',
                title: t(tokens.common.add_zone),
                text: t(tokens.inventory.enter_location_zone_name),
            })
            return
        }

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.common.add_zone),
            text: t(tokens.inventory.confirm_location_zone_addition),
            isConfirm: true,
        })

        if (!isConfirm) return

        const result = await $http().put('/inventory/add-area', area)
        if (result) {
            $toast({ title: t(tokens.common.success), text: t(tokens.inventory.zone_added), icon: 'success' })
            props.onHide(true)
        }
    }

    const onChange = (type: string, value: string) => {
        setArea({
            ...area,
            [type]: value,
        })
    }

    const header = (title: string) => {
        return <div className="col-12 flex grid py-0">{title}</div>
    }

    return (
        <Dialog
            header={header(t(tokens.common.add_zone))}
            visible={props.visible}
            onHide={() => props.onHide(false)}
            closable={false}
            contentClassName="pb-0"
        >
            {props.visible && (
                <div className="grid">
                    <div className="col-3 flex mb-3 font-bold mt-2 align-items-center pl-2">{t(tokens.inventory.zone_name)}</div>
                    <div className="col-9 flex mb-3 mt-2 px-0">
                        <InputText
                            value={area.areaNm}
                            className="p-inputtext w-full"
                            placeholder={t(tokens.common.enter_zone_name)}
                            onChange={(e) => onChange('areaNm', e.currentTarget.value)}
                        />
                    </div>

                    <div className="col-6 flex mb-2 pl-0">
                        <Button
                            className="w-full p-button-secondary"
                            label={t(tokens.common.cancel)}
                            size="large"
                            onClick={() => props.onHide(false)}
                        />
                    </div>
                    <div className="col-6 flex mb-2 pr-0">
                        <Button className="w-full p-button-success" label={t(tokens.common.add)} size="large" onClick={onClickSave} />
                    </div>
                </div>
            )}
        </Dialog>
    )
}

export default AreaAddDialog
